
import { useEffect, useState } from 'react'

export default function AdvCarousel({data, theme}) {
    const [place, setPlace] = useState(0);
    useEffect(()=>{
        const spin = setInterval(() => {
            setPlace((prevPlace)=>{return (prevPlace+1) % data.advs.length});
        }, 5000);
        return ()=>{
            clearInterval(spin);
        }
    },[])
    return (
        <img className='exampleHomePage_adv' style={{border:`0.5px solid ${theme.primary_color}`}} src={`${data.advs[place]}`}></img>
    )
}
